




























import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'params_edit'

    props:
        date:
            required: true
        new_params:
            required: true

    watch:
        new_params: (new_one, old_one)->
            if new_one != {}
                @params = new_one

    data: ()->
        active_names: [1]
        delta_min: 0
        day_min: 1
        max: 31
        params: {
            uid: ''
            max_date_delta: 3
            sending_day: 1
        }

    computed:
        params_readonly: ()->
            readonly = t.has_access_right('vpe_edit_params')
            return !readonly

        next_month: ()->
            next = new Date(@date)
            if @params.sending_day < 15
                next.setMonth(next.getMonth()+1)
            return next.toLocaleDateString('fr-FR', {month:'long', year:'numeric'})

    methods:
        # get_variable_payroll_params: ()->
        #     self = @
        #     q.run('get_variable_payroll_params', [@$store.getters.current_company.uid])
        #     .then (resp)->
        #         if resp.body.errors? and resp.body.errors.length > 0
        #             for e in resp.body.errors
        #                 n.gql_error("params_edit: get_variable_payroll_params: then", e.message)
        #         else
        #             console.log "GET VARIABLE PAYROLL PARAMS : ", resp.body.data.variable_payroll_params
        #             if resp.body.data.variable_payroll_params != null
        #                 self.params = resp.body.data.variable_payroll_params
        #     .catch (resp)->
        #         n.catch_error(resp, "params_edit: get_variable_payroll_params()")

        save_params: ()->
            # console.log "SAVE PARAMS", @params
            @params.company_uid = @$store.getters.current_company.uid
            @params.max_date_delta += ' 00:00:00'
            self = @
            m.run('save_variable_payroll_params', [@params])
            .then (resp)->
                if resp.body.data.variable_payroll_params_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.variable_payroll_params_form_mutation.errors.length > 0
                    self.errors = resp.body.data.variable_payroll_params_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    # self.get_variable_payroll_params()
                    self.$emit('update-params')
                    n.success()
            .catch (resp)->
                n.catch_error(resp, "params_edit: save_params()")
            
    # beforeMount: ()->
        # @get_variable_payroll_params()
}
